<!-- Iframe (md+): 3-column grid with equal side columns so the neighbors pill is truly centered -->
<nav
    #topbarContainer
    id="Topbar"
    class="pointer-events-auto w-full flex justify-between px-4 relative md:static"
    [class]="iframeMode ? 'pt-4 items-start md:grid md:grid-cols-[1fr_auto_1fr]' : 'h-12 items-center'"
    role="navigation"
    aria-label="Main navigation"
    [class.iframe-mode]="iframeMode"
    [class.fullscreen-active]="isFullscreen()"
>

    @if(hyperlinkMode) {

    <div class="w-8 md:w-1/3"></div>

    <div class="neighbors-cell md:w-1/3">
        <app-neighbors/>
    </div>

    <div class="w-8 md:w-1/3 flex md:justify-end"
         [class.on-dark]="rightMode() === 'on-dark'"
         [class.on-light]="rightMode() === 'on-light'"
         [class.hover-neutral]="iframeMode">
        <app-fullscreen-toggle/>
    </div>

    } @else {

    <!-- MAIN BAR — hidden on mobile in iframe mode while viewing a seatmap or pano; back-button + neighbors row below takes over -->
    @if(!(iframeMode && !isTopLevelView() && isMobile())) {

    <!-- BUTTONS & MENUS -->
    <div class="w-auto flex items-center"
         [class.on-dark]="leftMode() === 'on-dark'"
         [class.on-light]="leftMode() === 'on-light'"
         [class.hover-neutral]="iframeMode">

        <!-- LEFT BUTTONS -->
        <app-navigation/>
        <app-brand/>

    </div>

    <!-- TITLE AND NEIGHBORS — only in iframe mode. Fixed w-80 like the non-iframe
         overlay (viewer-layout), so the pill geometry is the same in both modes;
         the grid's equal 1fr side columns keep it centered. -->
    @if(iframeMode) {
        <div class="neighbors-cell md:w-80">
            <app-neighbors/>
        </div>
    }

    <!-- OTROS -->
    <div class="w-auto md:flex-1 flex items-center justify-end gap-x-2"
         [class.on-dark]="rightMode() === 'on-dark'"
         [class.on-light]="rightMode() === 'on-light'"
         [class.hover-neutral]="iframeMode">

        @if(!isMobile() && !searchOpen()){
            <app-benefits />
        }

        @if(!isMobile() && !searchOpen()){
            <app-menu/>
        }

        @if(!isMobile()){
            <app-search class="min-w-0 md:max-w-80" [class.flex-1]="searchOpen()" [inline]="true"/>
        }

        @if(!iframeMode){
            <app-legend/>
        }

        @if(isMobile()){
            <app-mobile-button/>
        }

        @if(!isMobile()){
            <app-hyperlink/>
        }

        @if(!isMobile()){
            <app-fullscreen-toggle/>
        }

    </div>


    <!-- ACTION BUTTONS MOBILE -->
    <div class="absolute right-4 top-full mt-4 md:hidden z-10"><app-link-action-buttons/></div>

    }

    <!-- SUB-NAV -->
    <div class="absolute top-full left-0 w-full md:hidden pointer-events-none px-4 pt-3 pb-16">
        <!-- Equal 1fr side columns keep the neighbors pill centered -->
        <div [class.hidden]="mobileButtonActive()" class="grid grid-cols-[1fr_auto_1fr] items-center">
            <div class="pointer-events-auto on-theme hover-neutral" [class.on-dark]="!isTopLevelView()"><app-back-button/></div>
            <div class="pointer-events-auto"><app-neighbors/></div>
            <div class="flex items-center justify-end gap-x-2 pointer-events-auto on-theme hover-neutral" [class.on-dark]="!isTopLevelView()">
                <app-fullscreen-toggle/>
                <app-hyperlink/>
            </div>
        </div>
    </div>

    }

</nav>
